import ReceivedAtDate from '../../components/ReceivedAtDate';
import PropTypes from 'prop-types';

import _, { cloneDeep } from 'lodash';
import moment from 'moment-timezone';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { ADD_NICK_NAME } from '../../actions/action-types';
import { openModalAction } from '../../actions/modal';
import CapTakesPlot from './CapTakesPlot';
import { Button } from '../../components/PageHeader/Button';
import {
  DATE_MONTH_DAY_YEAR,
  LOCAL_TIMEZONE,
  TIME_FORMAT_12_UPPERCASE,
  DATE_MONTH_DAY_YEAR_WITH_DASH,
  TIME_FORMAT_WEEKDAY_AMPM,
} from '../../constants';
import Table, { Column } from '../../containers/Table/TableWithPagination';
import Strings from '../../Strings';
import { getFullLocation, getLocation, signalRender } from '../../utils';
import { isShipper, isSuperUser } from '../../utils/userRoles';
import { actions } from './redux/actions';
import styles from './style.module.scss';
import { PageHeader } from '../../components/PageHeader';
import AdvancedFilters, { Filter } from '../../components/AdvancedFilters/AdvancedFilters';
import AdvancedFiltersBar from '../../components/AdvancedFilters/AdvancedFiltersBar';
import { getRelevantFilters, urlInjected } from '../../components/AdvancedFilters/helpers';
import { DeviceClass, DeviceTypes } from '../../utils/deviceTypes';
import { getGlobalPageSize } from '../../utils/tableUtils';
import { EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME } from '../../modals/EditDeviceSampleStatusModal';
import { BatteryWithChargingStatus } from '../../components/ChargingStatus/ChargingStatus';
import { getChargingActivityType, getChargingActivityValue } from '../../components/ChargingStatus/chargingEvents';

const getTimezoneOffsetStr = offset => {
  if (offset == null) {
    return Strings.na;
  }
  // -128 * 15 - special value for invalid timezone
  if (offset == -1920) {
    return Strings.invalidTimezone;
  }
  return `${offset > 0 ? '+' : ''}${offset} min`;
};

export const getHWValue = (e) => {
  if (e.activity_type == 'Signal strength') {
    return signalRender(e.activity_value);
  } else if (e.activity_type == 'Location') {
    const localizationStr = e.activity_value.city ? e.activity_value.city : '-';
    const operatorStr = e.activity_value.network_operator ? '(' + e.activity_value.network_operator + ')' : '';
    let offsetStr = '';
    if (isSuperUser() && (e.activity_value.used_timezone_offset || e.activity_value.network_timezone_offset)) {
      offsetStr = `offsetStr = [TZ: ${getTimezoneOffsetStr(
        e.activity_value.used_timezone_offset,
      )}, TZN: ${getTimezoneOffsetStr(e.activity_value.network_timezone_offset)}]`;
    }

    return localizationStr + ' ' + operatorStr + ' ' + offsetStr;
  }

  const chargingValue = getChargingActivityValue(e);
  if (chargingValue !== undefined) {
    return isShipper() ? `${chargingValue} (${e.hw_code})` : chargingValue;
  }

  const compartmentTime = e.activity_value?.expected_compartment_time ? moment.parseZone(e.activity_value.expected_compartment_time) : '';
  const value = compartmentTime
    ? `${e.activity_value.message} (${compartmentTime.format(TIME_FORMAT_WEEKDAY_AMPM)})`
    : typeof e.activity_value === 'object'
    ? JSON.stringify(e.activity_value) 
    : e.activity_value;
  return isShipper() ? `${value ?? ''} (${e.hw_code})` : value;
};

export const getActivityType = e => getChargingActivityType(e) || e.activity_type || '-';

const mapStateToProps = state => {
  const { profile } = state.auth;
  const access = profile?.access;
  return {
    isLoading: state.shipper.capsDetails.isLoading,
    details: state.shipper.capsDetails.data,
    plotData: state.shipper.capsDetails.plotData,
    plotScheduleData: state.shipper.capsDetails.plotScheduleData,
    pagination: state.shipper.capsDetails.data?.pagination,
    access,
    timezone: state.auth?.profile?.preferences?.timezone,
    filters: state.entities.advancedFilters.filters.items,
    globalPageSize: getGlobalPageSize(state),
  };
};

const mapDispatchToProps = dispatch => ({
  getFillterData: id => dispatch(actions.getFillterData(id)),
  getCapsDetails: (id, pageRequest) => dispatch(actions.getCapsDetails(id, pageRequest)),
  clearCapsDetails: () => dispatch(actions.clearCapsDetails()),
  getPlotScheduleDetail: (id, request) => dispatch(actions.getPlotScheduleDetail(id, request)),
  getPlotData: (id, request) => dispatch(actions.getPlotData(id, request)),
  onAddNickName: (pageRequest, capName, id) =>
    dispatch(
      openModalAction('add-nick-name', {
        action: actions.addNickName,
        actionType: ADD_NICK_NAME,
        id,
        nextAction: actions.getCapsDetails,
        pageRequest,
        capName,
        allowEmpty: true,
      }),
    ),
  openSampleStatusModal: data => dispatch(openModalAction(EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME, data)),
  navigate: path => dispatch(push(path)),
});

const getFilterItems = filters => {
  const ret = [];
  /* eslint-disable */
  for (const i in filters) {
    ret.push({
      id: filters[i].type,
      value: filters[i].value,
    });
  }
  /* eslint-enable */
  return ret;
};

export function getActivityTypeFilter(activityTypes) {
  return {
    activityType: {
      group: 'activityType',
      text: Strings.eventType,
      values: activityTypes.map(a => {
        return { text: a.value, value: a.id };
      }),
    },
  };
}

export const getCapHeader = (
  details,
  type,
  editCapName,
  showBackButton,
  color = undefined,
  editSampleStatus,
  timezone,
) => {
  return (
    <div className={`infoHeader ${color ? color : ''}`}>
      <div className="rowDirection">
        {showBackButton && (
          <button className="back" onClick={() => history.back()} tabIndex={0}>
            {Strings.back}
          </button>
        )}
        <div className="feildBox">
          {Strings.deviceName}:{' '}
          <div className="feildValue val">{details?.cap_name?.toString() ? details?.cap_name?.toString() : '-'} </div>
          {isShipper() ? (
            ''
          ) : (
            <div className="feildValue edit">
              <div className="editImg" data-testid="edit-device-name" onClick={editCapName} />
            </div>
          )}
        </div>

        {DeviceTypes[type]?.deviceClass === DeviceClass.cap || DeviceTypes[type]?.deviceClass === DeviceClass.hub ? (
          <React.Fragment>
            <div className="pathHr" />
            <div className="feildBox">
              {Strings.imei}: <div className="feildValue val">{details?.imei ? details?.imei : '-'}</div>
            </div>
          </React.Fragment>
        ) : (
          ''
        )}
        <div className="pathHr" />
        <div className="feildBox">
          {Strings.deviceId}: <div className="feildValue val">{details?.cap_id ? details?.cap_id : '-'}</div>
        </div>
        {details?.kit_id && (
          <>
            <div className="pathHr" />
            <div className="feildBox">
              {Strings.kitId}: <div className="feildValue val">{details?.kit_id ? details?.kit_id : '-'}</div>
            </div>
          </>          
        )}
        {isSuperUser() && (
          <React.Fragment>
            <div className="pathHr" />
            <div className="feildBox">
              {Strings.deviceInvoices.sample}:
              <div className="feildValue val">{details?.is_sample ? Strings.yes : Strings.no}</div>
              <div className="feildValue edit">
                <div className="editImg" data-testid="edit-device-sample-status" onClick={editSampleStatus} />
              </div>
            </div>
          </React.Fragment>
        )}
        {DeviceTypes[type]?.deviceClass === DeviceClass.cap || DeviceTypes[type]?.deviceClass === DeviceClass.hub ? (
          <React.Fragment>
            <div className="pathHr" />
            <div className="feildBox">
              {Strings.network}:{' '}
              <div
                className="feildValue val"
                data-tooltip-content={`${Strings.networkTime}: 
                ${
                  details?.last_network_connection_status
                    ? details?.last_network_connection_status !== 'OK'
                      ? details?.last_network_connection_status
                      : moment(details?.last_network_connection).format(DATE_MONTH_DAY_YEAR_WITH_DASH)
                    : 'N/A'
                }`}
                data-tooltip-id="tooltip"
              >
                {details?.last_network_operator ? details?.last_network_operator : '-'}
              </div>
            </div>
          </React.Fragment>
        ) : (
          ''
        )}
      </div>

      <div className="rowDirection left">
        {DeviceTypes[type]?.deviceClass === DeviceClass.cap || DeviceTypes[type]?.deviceClass === DeviceClass.hub ? (
          <React.Fragment>
            <div className="feildBox">
              {Strings.location}:{' '}
              <div className="feildValue val">
                {details?.location?.toString() ? (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://maps.google.com/?q=${getFullLocation(details?.location?.toString())}`}
                  >
                    {getLocation(details?.location?.toString())}
                  </a>
                ) : (
                  '-'
                )}
              </div>
            </div>
            <div className="pathHr" />
            <div className="feildBox">
              {Strings.signal}: <div className="feildValue val">{signalRender(details?.signal_strength)}</div>
            </div>
            <div className="pathHr" />
          </React.Fragment>
        ) : (
          ''
        )}
        <div className="feildBox">
          {Strings.battery.battery}:{' '}
          <div className="feildValue">
            <BatteryWithChargingStatus
              battery={details?.battery}
              batteryMeasuredAt={details?.battery_measured_at}
              chargingStatus={details?.charging_status}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
class ShipperCapsDetails extends PureComponent {
  type = 'all';
  offset = 0;
  filterItems = [];
  plotDateRanges = [];
  selectedPlotDateRange = undefined;
  refreshEnable = true;
  hasFiltersInUrl = urlInjected(window.location.search);
  hasSeenHydratedFilters = false;
  state = {
    plotSelectedRefHourIndex: undefined,
    graphMinDate: undefined,
    graphMaxDate: undefined,
  };
  pageRequest = {};
  patientId = this.props.match.params.patientId;

  pageRequest = {
    offset: 0,
    search: '',
    limit: this.props.globalPageSize,
    activityType: this.type,
  };

  componentDidMount() {
    // due to the fact that we more than 1 route that leads to this component, they uses id as userId, but some of them it as deviceId.
    // if deviceId is present, we will use it instead of id.
    if (this.props.match.params?.deviceId) {
      this.deviceId = this.props.match.params?.deviceId;
    } else {
      this.deviceId = this.props.match.params.id;
    }

    this.loadAllData();
  }

  componentWillUnmount() {
    this.props.clearCapsDetails();
  }

  componentDidUpdate(prevProps) {
    const { filters } = this.props;
    if (filters !== prevProps.filters) {
      if (this.hasFiltersInUrl && !this.hasSeenHydratedFilters && filters.length === 0) {
        return;
      }
      if (filters.length > 0) {
        this.hasSeenHydratedFilters = true;
      }
      this.onFiltersChange(filters);
    }
  }

  loadAllData() {
    const type = this.props.match.params.type || this.props.match.params.deviceType;

    if (type !== DeviceTypes.Datahub.id) {
      this.props.getPlotScheduleDetail(this.deviceId, this.patientId ? { patient_id: this.patientId } : undefined).then(r => {
        this.startDate = r.response.start_date
          ? moment(r.response.start_date * 1000).startOf('day')
          : moment()
              .subtract(1, 'month')
              .startOf('day');
        this.endDate =
          !r.response.end_date || moment(r.response.end_date) > moment()
            ? moment().endOf('day')
            : moment(r.response.end_date * 1000).endOf('day');
        this.setState({ graphMinDate: this.startDate, graphMaxDate: this.endDate });
        this.loadPlot();
      });
    }

    this.props.getFillterData(this.deviceId).then(r => {
      this.filterItems = getFilterItems(r.response.data);
      if (!this.hasFiltersInUrl) {
        this.load();
      }
    });
  }

  load() {
    if (this.patientId) {
      this.pageRequest.patient_id = this.patientId;
    }

    this.props.getCapsDetails(this.deviceId, this.pageRequest);
  }

  loadPlot() {
    if (!this.startDate || !this.endDate) return;
    const request = {
      startDate: this.startDate.format(),
      endDate: this.endDate.format(),
      patient_id: this.patientId,
    }
    this.props.getPlotData(this.deviceId, request);
  }

  onFiltersChange = _.debounce(() => {
    this.pageRequest.offset = 0;
    const type = getRelevantFilters(this.props.filters.filter(f => f.group === 'activityType'));
    if (type?.length > 0) {
      this.pageRequest.activityType = type.map(f => f.value).join(',');
    } else {
      this.pageRequest.activityType = 'all';
    }
    this.load();
  }, 1000);

  // for plots with selecting refHour
  _unused_onRefHourChange = value => {
    if (!isNaN(value)) {
      let refHours = cloneDeep(this.state.graphRefHours);
      refHours.forEach((rh, i) => {
        rh.selected = i.toString() === value.toString();
      });
      this.setState({ graphRefHours: refHours });
    }
  };

  onOffsetChange = (offset, limit) => {
    this.pageRequest.offset = offset;
    if (limit) {
      this.pageRequest.limit = limit;
    }
    this.load();
  };

  onSortClick = ({ sortKey, direction }) => {
    this.pageRequest.offset = 0;
    this.pageRequest.sortColumn = sortKey;
    this.pageRequest.sortType = direction;
    this.props.getCapsDetails(this.deviceId, this.pageRequest);
  };

  cityDisplay = value => {
    const location = value.split('"');
    const index = location.findIndex(e => e == 'city');
    if (index != -1) {
      return location[index + 2];
    }
    return '-';
  };

  onRefresh = () => {
    this.refreshEnable = false;
    this.turnOffTimeout = setTimeout(() => {
      this.refreshEnable = true;
      this.forceUpdate();
    }, 10000);
    this.loadAllData();
  };

  onEditSampleStatus = () => {
    this.props.openSampleStatusModal({
      capDetailsRequest: this.pageRequest,
      deviceId: this.props.details?.cap_id || this.deviceId,
      isSample: !!this.props.details?.is_sample,
      onSuccess: () => this.load(),
    });
  };

  render() {
    const { details, isLoading, pagination, onAddNickName, plotData, plotScheduleData } = this.props;
    const { graphMinDate, graphMaxDate } = this.state;
    const { type } = this.props.match.params;

    const inner =
      isLoading && !this.refreshEnable ? (
        <div className="pagination-spinner-container">
          <div className="spinner" />
        </div>
      ) : (
        ''
      );

    return (
      <React.Fragment>
        {!this.props.noHeader &&
          getCapHeader(
            details,
            type,
            () => onAddNickName(this.pageRequest, details?.cap_name, this.deviceId),
            this.props.showBackButton,
            undefined,
            this.onEditSampleStatus,
            this.props.timezone,
          )}
        {this.plotDateRanges && this.plotDateRanges.length > 0 && (
          <PageHeader
            noLeftPadding
            right={
              <React.Fragment>
                <Button class="refresh" disabled={!this.refreshEnable} onClick={this.onRefresh} />
              </React.Fragment>
            }
          />
        )}
        {inner}

        {plotData && graphMinDate && graphMaxDate && (
          <div className={styles.chart}>
            <CapTakesPlot
              plotData={plotData}
              plotScheduleData={plotScheduleData}
              graphMinDate={graphMinDate}
              graphMaxDate={graphMaxDate}
              // onSelectRefHourIndex={this.onRefHourChange.bind(this)}
            />
          </div>
        )}
        <PageHeader
          noLeftPadding
          left={
            this.filterItems?.length > 0 && (
              <AdvancedFilters expandToRight>
                <Filter definition={getActivityTypeFilter(this.filterItems).activityType} />
              </AdvancedFilters>
            )
          }
          right={
            (!this.plotDateRanges || this.plotDateRanges.length == 0) && (
              <React.Fragment>
                <Button class="refresh" disabled={!this.refreshEnable} onClick={this.onRefresh} />
              </React.Fragment>
            )
          }
        />
        {this.filterItems?.length > 0 && <AdvancedFiltersBar customFilters={getActivityTypeFilter(this.filterItems)} />}

        <Table
          isLoading={isLoading}
          name="capsDetails"
          data={details?.activity ?? []}
          onOffsetChange={this.onOffsetChange}
          pagination={pagination}
          onSortClick={this.onSortClick}
        >
          <Column
            key="timestamp"
            sortKey="timestamp"
            title={Strings.date}
            value={e => {
              const displayDate = e.timestamp
                ? (e.tzinfo === LOCAL_TIMEZONE ? moment.unix(e.timestamp).tz(this.props.timezone) : moment.unix(e.timestamp).utc())
                : null;
              return (
                <ReceivedAtDate
                  measuredAt={e.timestamp ? moment.unix(e.timestamp) : null}
                  backendTimestamp={e.backend_timestamp}
                  displayReference={displayDate}
                  displayFormat={`${DATE_MONTH_DAY_YEAR} ${TIME_FORMAT_12_UPPERCASE}`}
                >
                  {displayDate ? displayDate.format(DATE_MONTH_DAY_YEAR) : '-'}
                </ReceivedAtDate>
              );
            }}
          />
          <Column
            key="timestampTime"
            title={Strings.time}
            value={e => {
              if (e.tzinfo === LOCAL_TIMEZONE) {
                return e.timestamp
                  ? moment
                      .unix(e.timestamp)
                      .tz(this.props.timezone)
                      .format(TIME_FORMAT_12_UPPERCASE)
                  : '-';
              }
              return e.timestamp ? moment.utc(moment.unix(e.timestamp)).format(TIME_FORMAT_12_UPPERCASE) : '-';
            }}
          />
          <Column
            key={Strings.eventType}
            title={Strings.eventType}
            value={getActivityType}
          />
          <Column
            key={Strings.value}
            title={Strings.value}
            value={e => {
              return getHWValue(e);
            }}
          />
        </Table>
      </React.Fragment>
    );
  }
}

ShipperCapsDetails.propTypes = {
  clearCapsDetails: PropTypes.func,
  details: PropTypes.shape({
    activity: PropTypes.array,
    battery: PropTypes.any,
    battery_measured_at: PropTypes.string,
    cap_id: PropTypes.shape({ toString: PropTypes.func }),
    cap_name: PropTypes.shape({ toString: PropTypes.func }),
    imei: PropTypes.any,
    location: PropTypes.shape({ toString: PropTypes.func }),
    signal_strength: PropTypes.any,
    is_sample: PropTypes.bool,
    charging_status: BatteryWithChargingStatus.propTypes.chargingStatus,
  }),
  getCapsDetails: PropTypes.func,
  getFillterData: PropTypes.func,
  getPlotData: PropTypes.func,
  getPlotScheduleDetail: PropTypes.func,
  isLoading: PropTypes.any,
  match: PropTypes.shape({
    params: PropTypes.shape({
      deviceId: PropTypes.any,
      id: PropTypes.any,
      type: PropTypes.string,
    }),
    url: PropTypes.shape({
      includes: PropTypes.func,
      replace: PropTypes.func,
    }),
  }),
  navigate: PropTypes.func,
  onAddNickName: PropTypes.func,
  openSampleStatusModal: PropTypes.func,
  pagination: PropTypes.shape({ offset: PropTypes.any }),
  plotData: PropTypes.any,
  plotScheduleData: PropTypes.any,
  filters: PropTypes.array,
  showBackButton: PropTypes.bool,
  noHeader: PropTypes.bool,
  timezone: PropTypes.string,
};

ShipperCapsDetails.defaultProps = { showBackButton: true, noHeader: false };

export default connect(mapStateToProps, mapDispatchToProps)(ShipperCapsDetails);
